import { gql } from '@apollo/client';

export const UpdateCSSStore = gql`
mutation UpdateCSSStore($idStore: ID, $content: String) {
  updateCSSStore(idStore: $idStore, content: $content) {
    status
  }
}
`;